import { inject, Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { Observable } from "rxjs";

@Injectable({ providedIn: "root" })
export class SettingsService {
	private httpClient = inject(HttpClient);

	fetchEtrackerSecureCode(): Observable<{ secureCode: string }> {
		return this.httpClient.get<{ secureCode: string }>("/api/v1/settings/etracker");
	}
}
